<div class="toolbar-user">
  <!-- Toggle button -->
  <button id="user-menu-button" mat-button aria-haspopup="true" [attr.aria-expanded]="isOpen" aria-controls="user-menu"
    (click)="toggleDropdown()" [matTooltip]="LangTextData.tooltipLabel.toolBoxUserProfile" matTooltipClass="table_tooltip_job_filename" matTooltipPosition="below" aria-label="user profile">
    <mat-icon aria-hidden="true">account_circle</mat-icon>
  </button>

  <!-- Dropdown menu -->
  <div id="user-menu" class="dropdown" [class.open]="isOpen" role="menu" (focusout)="onFocusOut($event)"
    (keydown.arrowdown)="onArrowDown($event)" (keydown.arrowup)="onArrowUp($event)">
    <div role="menuitem" tabindex="0" class="list-item" (click)="profile()" (keydown.enter)="profile()">
      <mat-icon aria-hidden="true">account_circle</mat-icon>
      <span>{{ LangTextData?.htmlLabel.userProfileText }}</span>
    </div>

    <div role="menuitem" tabindex="0" class="list-item" (click)="logoutClicked()" (keydown.enter)="logoutClicked()">
      <mat-icon aria-hidden="true">exit_to_app</mat-icon>
      <span>{{ LangTextData?.htmlLabel.userProfileLogoutText }}</span>
    </div>
  </div>
</div>